import AccountantLayout from '../components/AccountantLayout';
import { EngineReviewDetailContent } from '../components/accountant/review/EngineReviewDetailContent';
import type { ReviewPanelMode } from '../types/engineReview';

interface Props { mode: ReviewPanelMode; }

export default function AccountantEngineReviewDetail({ mode }: Props) {
  const content = <EngineReviewDetailContent mode={mode} />;
  return mode === 'external' ? <AccountantLayout>{content}</AccountantLayout> : content;
}